export const getDays = (state) => state.days